module.exports = __webpack_public_path__ + "static/media/step1.f5b19d26.svg";